import { useEffect, useRef, useState } from 'react';
import type { ConnectionState } from '../components/LiveStatusDot.js';

export interface UseEventStreamOptions {
  topics: string[];
  onEvent?: (event: MessageEvent) => void;
  since?: Record<string, number>;
}

export function useEventStream(opts: UseEventStreamOptions) {
  const [connection, setConnection] = useState<ConnectionState>('disconnected');
  const ref = useRef<EventSource | null>(null);

  useEffect(() => {
    if (opts.topics.length === 0) {
      setConnection('disconnected');
      return;
    }

    setConnection('reconnecting');
    const params = new URLSearchParams();
    params.set('topics', opts.topics.join(','));
    if (opts.since) params.set('since', JSON.stringify(opts.since));

    const es = new EventSource(`/api/stream?${params.toString()}`);
    ref.current = es;

    es.onopen = () => setConnection('connected');
    es.onerror = () => setConnection('reconnecting');
    if (opts.onEvent) es.onmessage = opts.onEvent;

    return () => {
      es.close();
      ref.current = null;
      setConnection('disconnected');
    };
  }, [opts.topics.join(','), JSON.stringify(opts.since)]);

  return { connection };
}
